import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMute"><Path d="M4.00015 21.4144L21.4144 4.00015L20.0002 2.58594L17 5.58609V3.07129L9.74656 7.00023H5V17.0002H5.58585L2.58594 20.0002L4.00015 21.4144Z" fill="currentColor"/><Path d="M17 20.9292L10.7173 17.5261L17 11.2434V20.9292Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMute;
